// Action Type Constants

export default {
    SET_DESTINATION: "SET_DESTINATION",
    SET_DESTINATION_LOCATION: "SET_DESTINATION_LOCATION",
    SET_ORIGIN: "SET_ORIGIN",
    SET_ORIGIN_LOCATION: "SET_ORIGIN_LOCATION",
    SET_OPEN_DRAWER: "SET_OPEN_DRAWER",
    SET_OPEN_TOUR: "SET_OPEN_TOUR",
    SET_DIRECTIONS: "SET_DIRECTIONS",
    SET_START_DIRECTIONS_ICON: "SET_START_DIRECTIONS_ICON",
    SET_END_DIRECTIONS_ICON: "SET_END_DIRECTIONS_ICON",
    SET_PENDING_REQUESTS: "SET_PENDING_REQUESTS",
    SET_FORM: "SET_FORM",
    SET_USER: "SET_USER",
    SET_TRAVEL: "SET_TRAVEL",
    SET_TRAVEL_TYPE: "SET_TRAVEL_TYPE",
    SET_TRAVEL_MOD: "SET_TRAVEL_MOD",
    SET_IS_OPEN_FLOAT_BUTTON: "SET_IS_OPEN_FLOAT_BUTTON",
    SET_PROVINCES: "SET_PROVINCES",
    SET_OWNERS: "SET_OWNERS",
    SET_CARS: "SET_CARS",
    SET_FILTER: "SET_FILTER",
}
